"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProviderCode = exports.getErrors = exports.getSellProvider = exports.getProvider = exports.formatter = exports.sanitizeInput = void 0;
const constants_1 = require("./constants");
const priorityCountries_1 = require("./priorityCountries");
const targetCountries_1 = require("./targetCountries");
// hacky min fix for cex currencies
const fiatMinCEX = {
    USD: 30,
    EUR: 30,
    GBP: 30,
    RUB: 3000,
};
const sanitizeInput = (str) => {
    return parseFloat(str.replace(/,/g, ""));
};
exports.sanitizeInput = sanitizeInput;
const formatter = (locale, currentFiat) => {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currentFiat,
    });
};
exports.formatter = formatter;
const getValue = (valueList, isMax, fiatCurr, cryptoCurr) => {
    if (isMax)
        return valueList.reduce((p, c) => {
            if (c.maxLimit && (c.maxLimit > p || p === 0))
                return c.maxLimit;
            return p;
        }, 0);
    return valueList.reduce((p, c) => {
        let min = c.minLimit;
        if (fiatCurr &&
            c.provider === "cex" &&
            cryptoCurr === "BTC" &&
            Object.keys(fiatMinCEX).includes(fiatCurr))
            min = fiatMinCEX[fiatCurr];
        if (min && (min < p || p === 0))
            return min;
        return p;
    }, 0);
};
// const isSafari = (): boolean => {
//   return (
//     navigator.userAgent.indexOf("Safari") > -1 &&
//     navigator.userAgent.indexOf("Chrome") <= -1
//   );
// };
const isBuyOrSellSubdomain = () => {
    const { hostname } = (window === null || window === void 0 ? void 0 : window.location) || "";
    const isBuyOrSell = hostname === "buy.bitcoin.com" || hostname === "sell.bitcoin.com";
    return isBuyOrSell;
};
const activateForPercentage = (percentage) => {
    return Math.random() < percentage;
};
const providerForGeo = (geo) => {
    const country = geo.alpha2 || "";
    const usState = geo.state || "";
    if ((country === "US" && constants_1.MOONPAY_STATES.includes(usState)) ||
        priorityCountries_1.MOONPAY_PRIORITY_COUNTRIES.includes(country))
        return "moonpay";
    if ((country === "US" && constants_1.SIMPLEX_STATES.includes(usState)) ||
        priorityCountries_1.SIMPLEX_PRIORITY_COUNTRIES.includes(country))
        return "simplex";
    if ((country === "US" && constants_1.CEX_STATES.includes(usState)) ||
        priorityCountries_1.CEX_PRIORITY_COUNTRIES.includes(country))
        return "cex";
    if (priorityCountries_1.RAMP_PRIORITY_COUNTRIES.includes(country))
        return "ramp";
    if ((country === "US" && constants_1.BANXA_STATES.includes(usState)) ||
        priorityCountries_1.BANXA_PRIORITY_COUNTRIES.includes(country))
        return "banxa";
    if (priorityCountries_1.MERCURYO_PRIORITY_COUNTRIES.includes(country) && isBuyOrSellSubdomain()) {
        return "mercuryo";
    }
    if (priorityCountries_1.TRANSAK_PRIORITY_COUNTRIES.includes(country)) {
        return "transak";
    }
    return null;
};
const getCustomProvider = (geo) => {
    const country = geo.alpha2 || "";
    const providers = {
        moonpay: targetCountries_1.MOONPAY_TARGET_COUNTRIES,
        simplex: targetCountries_1.SIMPLEX_TARGET_COUNTRIES,
        ramp: targetCountries_1.RAMP_TARGET_COUNTRIES,
        banxa: targetCountries_1.BANXA_TARGET_COUNTRIES,
        mercuryo: targetCountries_1.MERCURYO_TARGET_COUNTRIES,
        transak: targetCountries_1.TRANSAK_TARGET_COUNTRIES,
    };
    const targetProviders = Object.keys(providers).filter((provider) => providers[provider].includes(country));
    const index = activateForPercentage(0.5) ? 1 : 0;
    if (!isBuyOrSellSubdomain() && targetProviders.includes("mercuryo")) {
        const mercuryoIndex = targetProviders.indexOf("mercuryo");
        const otherProvider = targetProviders[mercuryoIndex === 0 ? 1 : 0];
        return otherProvider;
    }
    if (targetProviders.length === 2)
        return targetProviders[index];
    return null;
};
const getProvider = (fiatProviders, fiatValue, availableProviders, provider, geo) => {
    if (provider)
        return provider;
    let newProvider = null;
    const geoProvider = providerForGeo(geo || {});
    const customProvider = getCustomProvider(geo || {});
    fiatProviders.forEach((p) => {
        if (!p.minLimit || !p.maxLimit)
            return;
        if (fiatValue < p.minLimit || fiatValue > p.maxLimit)
            return;
        if (geoProvider && availableProviders.includes(geoProvider))
            newProvider = geoProvider;
        if (customProvider && availableProviders.includes(customProvider))
            newProvider = customProvider;
        if (!newProvider && availableProviders.includes(p.provider))
            newProvider = p.provider;
    });
    if (newProvider === null)
        return availableProviders[0];
    return newProvider;
};
exports.getProvider = getProvider;
const getSellProvider = (defaultProvider, provider, geo) => {
    if (provider)
        return provider;
    let newProvider = null;
    const country = (geo === null || geo === void 0 ? void 0 : geo.alpha2) || "";
    const usState = (geo === null || geo === void 0 ? void 0 : geo.state) || "";
    if ((country === "US" && constants_1.MOONPAY_SELL_STATES.includes(usState)) ||
        constants_1.MOONPAY_SELL_COUNTRIES.includes(country)) {
        newProvider = "moonpay";
    }
    if (constants_1.BANXA_SELL_COUNTRIES.includes(country))
        newProvider = "banxa";
    if (constants_1.MERCURYO_SELL_COUNTRIES.includes(country) && isBuyOrSellSubdomain()) {
        newProvider = "mercuryo";
    }
    if (newProvider === null)
        return defaultProvider;
    return newProvider;
};
exports.getSellProvider = getSellProvider;
const getErrors = (props) => {
    const { fiatValue, cryptoValue, selectedCrypto, selectedFiat, locales } = props;
    let fiatError = "";
    let cryptoError = "";
    const supportedProviders = selectedFiat.providers.filter((p) => {
        return selectedCrypto.providers.find((c) => c.provider === p.provider);
    });
    const minFiatValue = getValue(supportedProviders, false, selectedFiat.code, selectedCrypto.code);
    const maxFiatValue = getValue(selectedFiat.providers, true);
    if (minFiatValue !== 0 && fiatValue < minFiatValue)
        fiatError = `${locales.min}: ${(0, exports.formatter)(locales.locale || "en", selectedFiat.code).format(minFiatValue)}`;
    if (maxFiatValue !== 0 && fiatValue > maxFiatValue)
        fiatError = `${locales.max}: ${(0, exports.formatter)(locales.locale || "en", selectedFiat.code).format(maxFiatValue)}`;
    const minCryptoValue = getValue(selectedCrypto.providers, false);
    const maxCryptoValue = getValue(selectedCrypto.providers, true);
    if (minCryptoValue !== 0 && cryptoValue < minCryptoValue)
        cryptoError = `${locales.min}: ${minCryptoValue}`;
    if (maxCryptoValue !== 0 && cryptoValue > maxCryptoValue)
        cryptoError = `${locales.max}: ${maxCryptoValue}`;
    if (!cryptoValue)
        cryptoError = "";
    if (!fiatValue)
        fiatError = "";
    return { fiat: fiatError, crypto: cryptoError };
};
exports.getErrors = getErrors;
const getProviderCode = (crypto, provider) => {
    var _a;
    if (typeof provider === "undefined") {
        return crypto;
    }
    const symbol = crypto.toUpperCase();
    return ((_a = constants_1.PROVIDER_CODES[provider]) === null || _a === void 0 ? void 0 : _a[symbol]) || symbol;
};
exports.getProviderCode = getProviderCode;
//# sourceMappingURL=helpers.js.map